module.exports = __webpack_public_path__ + "static/showcase_movie-search.33771cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase_movie-search.png
// module id = 447
// module chunks = 111930841657428